var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.651367V24.6514H32V0.651367H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1525_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.651367V24.6514H32V0.651367H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1525_372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.651367V8.65137H32V0.651367H0Z",
    fill: "#FF8C1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.6514V24.6514H32V16.6514H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.65137C18.2091 8.65137 20 10.4422 20 12.6514C20 14.8605 18.2091 16.6514 16 16.6514C13.7909 16.6514 12 14.8605 12 12.6514C12 10.4422 13.7909 8.65137 16 8.65137ZM16 9.65137C14.3431 9.65137 13 10.9945 13 12.6514C13 14.3082 14.3431 15.6514 16 15.6514C17.6569 15.6514 19 14.3082 19 12.6514C19 10.9945 17.6569 9.65137 16 9.65137Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9944 13.5121L15.4236 16.6326L15.7551 13.4777L14.3282 16.311L15.5351 13.3772L13.3678 15.6938L15.3523 13.2188L12.6201 14.8309L15.2216 13.0154L12.1459 13.7925L15.1534 12.7833L11.9834 12.6624L15.1534 12.5415L12.1459 11.5324L15.2216 12.3095L12.6201 10.4939L15.3523 12.106L13.3678 9.63107L15.5351 11.9476L14.3282 9.01384L15.7551 11.8472L15.4236 8.69219L15.9944 11.8128L16.5653 8.69219L16.2338 11.8472L17.6607 9.01384L16.4538 11.9476L18.6211 9.63107L16.6366 12.106L19.3688 10.4939L16.7673 12.3095L19.843 11.5324L16.8355 12.5415L20.0055 12.6624L16.8355 12.7833L19.843 13.7925L16.7673 13.0154L19.3688 14.8309L16.6366 13.2188L18.6211 15.6938L16.4538 13.3772L17.6607 16.311L16.2338 13.4777L16.5653 16.6326L15.9944 13.5121Z",
    fill: "#3D58DB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.fc185b46295bb72785d2fc4253de2bdc.svg";
export { ForwardRef as ReactComponent };